import { NavLink } from 'react-router-dom';
import './SiteNavigation.css';

const links = [
  { to: '/atlas', label: 'Atlas' },
  { to: '/applications', label: 'Future Apps' },
  { to: '/privacy', label: 'Privacy' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

export default function SiteNavigation() {
  return (
    <header className="site-nav">
      <NavLink className="site-nav__brand" to="/" aria-label="Atlas Creative Labs home">
        <img
          className="site-nav__mark"
          src="/favicon.svg"
          alt=""
          aria-hidden="true"
        />
        <span className="site-nav__name">Atlas Creative Labs</span>
      </NavLink>

      <nav className="site-nav__links" aria-label="Primary navigation">
        {links.map(({ to, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) => `site-nav__link${isActive ? ' is-active' : ''}`}
          >
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="site-nav__actions">
        <NavLink className="site-nav__cta" to="/pre-alpha">
          Join Pre-Alpha
        </NavLink>

        <details className="site-nav__mobile-menu">
          <summary aria-label="Open navigation menu">Menu</summary>
          <nav aria-label="Mobile navigation">
            {links.map(({ to, label }) => (
              <NavLink key={to} to={to}>{label}</NavLink>
            ))}
          </nav>
        </details>
      </div>
    </header>
  );
}
